/**
 * Base class for elements whose markup is rendered on the server. The element adds behaviour only: render()
 * returns nothing, so AnJS leaves the server's children in place and init() runs once they are connected.
 */

// Dependencies
import { AnJSElement } from 'almostnojs';

/**
 * A server-rendered AnJS element.
 */
export class Enhanced extends AnJSElement {

    /**
     * No client template: the markup is already in the page.
     *
     * @returns {null} Nothing to render.
     */
    render() {

        // Keep the server's markup.
        return null;
    }

    /**
     * Listen on a target and remove the listener when the element disconnects.
     *
     * @param {EventTarget} target - Window, document, media query or element.
     * @param {string} type - Event type.
     * @param {Function} handler - Listener.
     * @param {Object} [options] - addEventListener options.
     * @returns {void}
     */
    listen(target, type, handler, options) {

        // Attach.
        target.addEventListener(type, handler, options);

        // Detach on disconnect.
        this.own(() => target.removeEventListener(type, handler, options));
    }
}

/**
 * Whether the visitor asked for reduced motion.
 *
 * @returns {MediaQueryList} The query (live).
 */
export const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)');
